import React, { useContext, useEffect, useState } from 'react'
import moment from 'moment-timezone'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

import { GlobalStateDataContext } from '../../context-api/data-provider/GlobalStateDataProvider'
import { Dialog } from '@mui/material';
import AtomicButton from '../../atomic/button/Button';
import { KitchenOperationUpdateContext } from '../../context-api/data-provider/UpdateOperationDataProvider';

const storeOpen = (operationStartTime, operationEndTime, userTimeZone) => {
    const start = moment(new Date(`${moment().format('ddd DD-MMM-YYYY')}, ${operationStartTime}`)).tz(userTimeZone)
    const end = moment(new Date(`${moment().format('ddd DD-MMM-YYYY')}, ${operationEndTime}`)).tz(userTimeZone)
    const current = moment().tz(userTimeZone)

    if (current.hours() < start.hours()) {
        current.add(1, 'days');
    }

    if (end.isSameOrBefore(start)) {
        end.add(1, 'days');
    }

    return { isOpen: current.isBetween(start, end, null, '[]'), diffMs: end.diff(current) };
}

const StoreOperationStatus = () => {
  const {
    OnLoadInformation,
    onLoadInfoResponse,
    showCongrat,
    showSignup,
    showPricePlan,
    isLoggedIn,
    setisLoggedIn,
    openSnackBar, setOpenSnackBar
  } = useContext(GlobalStateDataContext)




  const { onKitchenOperationUpdateAPI,
    kitchenUpdateAPIResponse,
    setKitchenUpdateAPIResponse, } = useContext(KitchenOperationUpdateContext)

  const [isStoreOpen, setIsStoreOpen] = useState(null)
  const [openStoreClosedPopup, setOpenStoreClosedPopup] = useState(false)
  const kitchenStartTime =
    onLoadInfoResponse?.data?.data?.data?.kitchenOperationObject
      ?.operation_start_time
  const kitchenEndTime =
    onLoadInfoResponse?.data?.data?.data?.kitchenOperationObject
      ?.operation_end_time
  const kitchenTimeZone =
    onLoadInfoResponse?.data?.data?.data?.KitchenInfo?.timeZone
  const KitchenClosedForShortTime =
    onLoadInfoResponse?.data?.data?.data?.kitchenOperationObject?.storeIsClosedForShortTime

  const HandleSubmitOperation = async () => {
    const operationPayload = {
      storeIsClosedForShortTime: KitchenClosedForShortTime ? false : true,
    }

    const data = await onKitchenOperationUpdateAPI(operationPayload)
    if (data?.customMessage === "Kitchen Operation details updated!" && data?.success) {
      setOpenStoreClosedPopup(false)
    } else {
      console.log('------Set error message')
    }

  }


  useEffect(() => {
    let timeout = null
    if (kitchenStartTime) {
      const userTimeZone = moment.tz.guess()
      const { isOpen, diffMs } = storeOpen(kitchenStartTime, kitchenEndTime, userTimeZone)

      if (!isOpen) {
        setIsStoreOpen(false)
      } else {
        setIsStoreOpen(true)
        timeout = setTimeout(() => {
          setIsStoreOpen(false)
        }, diffMs)
      }
    }

    return () => {
      if (timeout) {
        clearTimeout(timeout)
      }
    }
  }, [kitchenEndTime, kitchenStartTime, kitchenTimeZone])

  if (isStoreOpen === null) {
    return null
  }

  const OpenIcon = () => {
    return (<div style={{ display: 'flex', alignItems: 'center' }}> OPEN <FiberManualRecordIcon style={{ color: 'green' }} /></div>)
  }

  const ClosedIcon = () => {
    if (KitchenClosedForShortTime) {
      return (<div style={{ display: 'flex', alignItems: 'center' }}> Closed For Short Time <FiberManualRecordIcon style={{ color: 'red' }} /></div>)
    }
    return (<div style={{ display: 'flex', alignItems: 'center' }}> CLOSED <FiberManualRecordIcon style={{ color: 'red' }} /></div>)
  }

  return (
    <>
      <button style={{
        color: 'Black',
        display: 'flex',
        justifyContent: 'center',
        marginRight: '20px',
        border: '1px solid white',
        borderRadius: '20px',
        padding: '0px 5px 0px 5px',
        cursor: 'pointer'
      }} onClick={() => { setOpenStoreClosedPopup(true) }}>
        {' '}
        {(KitchenClosedForShortTime || !isStoreOpen) ? ClosedIcon() : OpenIcon()}
      </button>

      <Dialog
        open={openStoreClosedPopup}
        onClose={() => { setOpenStoreClosedPopup(false) }}  // This will close dialog if it clicked anywhere on screen
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="alert-dialog-wrapper"
      >


        <div style={{
          display: 'flex',
          // justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'center',
          minWidth: 'calc(90vw - 0px)',
          marginTop: '5%',
          height: '200px'
        }}>

          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            flexWrap: 'wrap',
            marginBottom: '20px'
          }}>
            <a style={{
              fontFamily: 'Inter Bold',
              marginBottom: '5px',
              letterSpacing: '0.5px'
            }}> {KitchenClosedForShortTime ? "The store is currently closed. Do you want to reopen it" : 'Confirmed: Closed for a short time'}</a>
            <a style={{
              fontFamily: 'Inter Regular',
              letterSpacing: '0.5px'
            }}> {KitchenClosedForShortTime ? "Reopening will make your store available for customers to place orders" : 'Confirming will make your store temporarily unavailable for customers to place orders'} </a>
          </div>



          <div style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}>

            <AtomicButton
              label="Cancel"
              handleSubmit={() => { setOpenStoreClosedPopup(false); }}
              style={{
                backgroundColor: '#fff4e7',
                width: "125px",
                marginRight: '10px',
                color: 'gray'
              }}
              loading={false}
              disabled={false}
            />
            <AtomicButton
              label={KitchenClosedForShortTime ? "Reopen store" : "Close Store Now"}
              handleSubmit={HandleSubmitOperation}
              style={{
                color: 'white',
                backgroundColor: KitchenClosedForShortTime ? '#81E7AF' : '#FF6363',
                width: "250px",
                margin: '0px',
                margin: '0px 5px 0px 10px'
              }}
              loading={false}
              disabled={false}
            />

          </div>


        </div>

      </Dialog>
    </>

  )
}

export default StoreOperationStatus
